import React from "react";
import "./style.scss";

interface CircularProgressProps {
  value: number;
  total: number;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  value,
  total,
}) => {
  const percentage = (value / total) * 100;

  return (
    <div className="progress-wrapper">
      <div
        className="progress-circle"
        style={{
          background: `conic-gradient(
                        from 180deg,
                        #133658 0deg,
                        #379fff ${percentage * 3.6}deg,
                        #e6eaee ${percentage * 3.6}deg
                    )`,
        }}
      >
        <div className="progress-circle inner-circle bg-white">
          <div className="progress-inner">
            <div className="progress-value">{value}</div>
            <div className="progress-text">hours of {total}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;
